// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"di-z"};